<template>
    <div class="content-section__column-manage-spacings order-manage-spacings">
        <div class="content plugin text-plugin">

            <div class="text-container">
                <h2>Bestellübersicht</h2>
            </div>
            <div class="text-container mt-24">
                <h2>Erste Lieferung</h2>
                <select v-model="deliveryDay" class="selectpicker delivery-selectpicker" data-container="body">
                    <option
                        v-for="(date, index) in validDeliveryDaysMethod()"
                        :key="index"
                        :value="date">{{ date | formatDate('dddd, D. MMMM YYYY') }}</option>
                </select>
            </div>
            <results-summary class="order-summary__subscription__col-container overview"/>

            <div class="order-result-block-1__link-container overview order-summary__col-container">
                <div class="order-cost-summary overview order-cost-summary__col-1">
                    <div class="order-cost-summary__label">
                        Preisübersicht
                    </div>
                    <div class="d-flex">
                        <div class="order-cost-summary__price-container">
                            <div class="order-cost-summary__price-total">
                                pro Woche: {{ (mode === 'private' ? total('all') : totalPerWeek('all')) | round | formatPrice }}
                            </div>
                            <div class="order-cost-summary__price-details">
                                pro {{ mode === 'business' ? 'Mitarbeiter' : 'Mitbewohner' }} / Woche: {{ (mode === 'private' ? totalPerPerson('all') : totalPerPersonPerWeek('all')) | round | formatPrice }}
                            </div>
                            <div class="order-cost-summary__price-details">
                                (inkl. Lieferung / exkl. MwSt. 2.6 %)
                            </div>
                        </div>
                        <div>
                            <a
                                href="#"
                                class="order-result-block-1__link-info"
                                @click.prevent="togglePriceSummaryModalVisible"
                            >
                                Preiszusammenstellung
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-container">
                <h2>Adressangaben</h2>
                <div class="order-summary__address__col-container">
                    <div class="order-summary__address__col-1">
                        <h3>Lieferadresse</h3>

                        <p>
                            {{ deliveryAdress.firstname }} {{ deliveryAdress.lastname }}<br>
                            {{ deliveryAdress.company }}<br>
                            {{ deliveryAdress.additional_shipping }}<br>
                            {{ deliveryAdress.street }}<br>
                            {{ deliveryAdress.zip }} {{ deliveryAdress.city }}
                        </p>
                    </div>
                    <div class="order-summary__address__col-2">
                        <h3>Rechnungsadresse</h3>

                        <p>
                            {{ invoiceAdress.firstname }} {{ invoiceAdress.lastname }}<br>
                            {{ invoiceAdress.company }}<br>
                            {{ invoiceAdress.additional_shipping }}<br>
                            {{ invoiceAdress.street }}<br>
                            {{ invoiceAdress.zip }} {{ invoiceAdress.city }}
                        </p>
                    </div>
                </div>
                <div class="divider"/>

                <h2>Kontaktangaben</h2>
                <div class="order-summary__address__col-container">
                    <div class="order-summary__address__col-1">
                        <h2 v-if="!sameInvoiceAddress">Lieferung</h2>
                        <h3>E-Mail-Adresse:</h3>
                        <span>{{ deliveryAdress.email_contact }}</span>
                        <h3>Telefon:</h3>
                        <span>{{ deliveryAdress.phone }}</span>
                        <h3>Mobiltelefon:</h3>
                        <span>{{ deliveryAdress.mobile }}</span>
                    </div>
                    <div v-if="!sameInvoiceAddress" class="order-summary__address__col-2">
                        <h2>Rechnung</h2>
                        <h3>E-Mail-Adresse:</h3>
                        <span>{{ invoiceAdress.email_contact }}</span>
                        <h3>Telefon:</h3>
                        <span>{{ invoiceAdress.phone }}</span>
                        <h3>Mobiltelefon:</h3>
                        <span>{{ invoiceAdress.mobile }}</span>
                    </div>
                </div>
                <div class="divider"/>

                <h2>Aboangaben</h2>
                <div class="order-summary__address__col-container">
                    <div class="order-summary__address__col-1">
                        <h3 v-if="invoiceAdress.additional_billing">Kostenstelle:</h3>
                        <span v-if="invoiceAdress.additional_billing">{{ invoiceAdress.additional_billing }}</span>

                        <h3 v-if="comment">Kommentar:</h3>
                        <span v-if="comment">{{ comment }}</span>

                        <h3>Wie hast du uns gefunden?</h3>
                        <span>{{ attention_by }}</span>
                    </div>
                    <div class="order-summary__address__col-2">
                        <template v-if="mode === 'business'">
                            <h3>Frühlieferung</h3>
                            <span v-if="earlyInvoice">Ja</span>
                            <span v-else>Nein</span>
                        </template>

                        <h3>Rechnung per Post zustellen</h3>
                        <span v-if="user.invoice_by_post">Ja</span>
                        <span v-else>Nein</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line
import { mapState, mapGetters } from 'vuex';

import priceMixin from '../../mixins/priceMixin';
import filters from '../../mixins/filters';
import ResultsSummary from '../ResultsOverview.vue';

export default {
    components: {
        ResultsSummary,
    },
    mixins: [
        priceMixin,
        filters,
    ],
    data() {
        return {
            deliveryDay: this.subscriptionType && this.subscriptionType.products[0].next_delivery_days[0],
        };
    },
    computed: {
        ...mapState({
            deliveryAdress: state => state.order.delivery_address,
            invoiceAdress: state => state.order.invoice_address,
            user: state => state.order.user,
            comment: state => state.order.comment,
            attention_by: state => state.order.attention_by,
            baskets: state => state.baskets,
            appetite: state => state.appetite,
            people: state => state.people,
            orderableSubscriptionTypes: state => state.orderable.product_groups,
            earlyInvoice: state => state.earlyInvoice,
            earlyDeliveryFee: state => state.orderable.earlyDeliveryFee,
            intervals: state => state.intervals,
            orderableIntervals: state => state.orderable.intervals,
            mode: state => state.mode,
            privateDeliveryDay: state => state.privateDeliveryDay,
            deliveryFee: state => state.orderable.deliveryFee,
            sameInvoiceAddress: state => state.sameInvoiceAddress,
            sortedBbasketsWednesday: state => state.sortedBbasketsWednesday,
            sortedBasketsMonday: state => state.sortedBasketsMonday,
        }),
        ...mapGetters([
            'subscriptionType',
            'amounts',
            'appetites',
            'orderableBaskets',
            'groupedBaskets',
            'allBaskets',
            'sortedBasketsMonday',
            'sortedBbasketsWednesday',
            'basketExtra',
            'groupedBasketsExtra',
        ]),
    },
    watch: {
        deliveryDay() {
            this.$store.commit('setFirstDeliveryDay', this.deliveryDay);
        },
        subscriptionType() {
            this.$store.commit('setFirstDeliveryDay', this.subscriptionType.products[0].next_delivery_days[0]);
        },
    },
    mounted() {
        window.scrollTo(0, 0);
        $('#order-disturber--header').remove();
        $(window).trigger('initBootstrapSelect');
        $('select').selectpicker();
        this.$store.commit('setFirstDeliveryDay', this.subscriptionType && this.subscriptionType.products[0].next_delivery_days[0]);
        // GTM VirtualPageview
        const { dataLayer } = window;
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: 'VirtualPageview',
                virtualPageURL: `/de/${this.mode === 'business' ? 'bio-furs-buro' : 'bio-fur-dihei'}/zusammenfassung`,
                virtualPageTitle: `Abo Bestellen ${this.mode === 'business' ? 'Büro' : 'Zuhause'} - Zusammenfassung`,
            });
        }
    },
    methods: {
        togglePriceSummaryModalVisible() {
            this.$store.commit('togglePriceSummaryOverviewModalVisible');
        },
        validDeliveryDaysMethod() {
            const nextDeliveryDays = this.subscriptionType.products[0].next_delivery_days;
            let validDeliveryDays = [];
            if (this.sortedBasketsMonday.length && !this.sortedBbasketsWednesday.length) {
                nextDeliveryDays.forEach((date) => {
                    const manipulatedDay = this.$options.filters.formatDate(date, 'dddd, D. MMMM YYYY');
                    if (manipulatedDay.includes('Montag')) {
                        validDeliveryDays.push(date);
                    }
                });
            } else if (this.sortedBbasketsWednesday.length && !this.sortedBasketsMonday.length) {
                nextDeliveryDays.forEach((date) => {
                    const manipulatedDay = this.$options.filters.formatDate(date, 'dddd, D. MMMM YYYY');
                    if (manipulatedDay.includes('Mittwoch')) {
                        validDeliveryDays.push(date);
                    }
                });
            } else {
                validDeliveryDays = this.subscriptionType.products[0].next_delivery_days;
            }
            $('.selectpicker').selectpicker('refresh');
            return validDeliveryDays;
        },
    },
};
</script>



// WEBPACK FOOTER //
// OrderSummary.vue?35b6b700